module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/homes_tomioka-05a1c3904dd39c58978155ddff9b7566.jpg";